module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "background-color": "#f9fbff"
    }
  }, [_c('v-snackbar', {
    attrs: {
      "timeout": _vm.snackbarTimeout,
      "top": _vm.y === 'top',
      "bottom": _vm.y === 'bottom',
      "right": _vm.x === 'right',
      "left": _vm.x === 'left',
      "multi-line": _vm.mode === 'multi-line',
      "vertical": _vm.mode === 'vertical'
    },
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.snackbarText) + "\n      "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "pink"
    },
    nativeOn: {
      "click": function($event) {
        _vm.snackbar = false
      }
    }
  }, [_vm._v("Close")])], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    staticStyle: {
      "margin-top": "-20px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "d-flex": "",
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-card-text', {
    staticStyle: {
      "margin-bottom": "-5px"
    }
  }, [_c('h3', [_vm._v("Phenolyzer")]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md12": "",
      "lg8": "",
      "xl8": ""
    }
  }, [_c('div', {
    staticStyle: {
      "display": "inline-block",
      "padding-top": "5px"
    },
    attrs: {
      "id": "phenotype-input"
    }
  }, [_c('label', [_vm._v("Enter Phenotype")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phenotypeTermEntered),
      expression: "phenotypeTermEntered"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.checked,
      "id": "phenotype-term",
      "type": "text",
      "autocomplete": "off",
      "placeholder": "Search phenotype (E.g. lactic acidosis)"
    },
    domProps: {
      "value": (_vm.phenotypeTermEntered)
    },
    on: {
      "focus": _vm.ClearInputForNewSearch,
      "keydown": _vm.EnterForSearch,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phenotypeTermEntered = $event.target.value
      }
    }
  }), _vm._v(" "), _c('typeahead', {
    attrs: {
      "hide-details": "false",
      "force-select": "",
      "match-start": "",
      "limit": _vm.typeaheadLimit,
      "async-function": _vm.phenotypeLookup,
      "target": "#phenotype-term",
      "item-key": "value"
    },
    model: {
      value: (_vm.phenotypeTerm),
      callback: function($$v) {
        _vm.phenotypeTerm = $$v
      },
      expression: "phenotypeTerm"
    }
  })], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "btnColor",
    staticStyle: {
      "margin-top": "-0.35px",
      "text-transform": "none",
      "color": "white"
    },
    on: {
      "click": _vm.getPhenotypeData
    }
  }, [_vm._v("\n                    Generate Gene List\n                  ")]), _vm._v(" "), (_vm.phenolyzerStatus !== null) ? _c('div', [_c('center', [_vm._v("\n                      Phenolyzer - "), _c('strong', [_vm._v(_vm._s(_vm.phenolyzerStatus))]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.checked),
      expression: "checked"
    }],
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "slot": "activator"
    },
    on: {
      "click": _vm.stopSearch
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("cancel_presentation")])], 1), _vm._v(" "), _c('span', [_vm._v("Cancel this search")])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.multipleSearchTerms.length) ? _c('div', [_c('br'), _vm._v("\n                      Phenotypes Searched:\n                    "), _vm._l((_vm.multipleSearchTerms), function(searchItem, i) {
    return _c('v-chip', {
      key: i,
      attrs: {
        "disabled": "",
        "color": "primary",
        "text-color": "white",
        "close": ""
      },
      on: {
        "input": function($event) {
          _vm.remove(searchItem)
        }
      }
    }, [_vm._v("\n                      " + _vm._s(i + 1) + ". " + _vm._s(searchItem) + "\n                    ")])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.noResultsArr.length) ? _c('div', [_c('br'), _vm._v("\n                    Searches with no results:\n                    "), _vm._l((_vm.noResultsArr), function(searchItem, i) {
    return _c('v-chip', {
      key: i,
      attrs: {
        "disabled": ""
      }
    }, [_vm._v("\n                      " + _vm._s(searchItem) + "\n                    ")])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.checked) ? _c('p', [_c('v-progress-linear', {
    attrs: {
      "height": "3",
      "color": "primary",
      "indeterminate": true
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('p')], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md12": "",
      "lg4": "",
      "xl4": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', [(_vm.items.length) ? _c('div', {
    staticClass: "d-flex mb-2 xs12 mb-3 genes-card-placeholder"
  }, [_c('v-card', [_c('v-card-text', [_c('center', [_c('span', {
    staticClass: "Rightbar_CardHeading"
  }, [_vm._v("\n                              GENES\n                              ")]), _vm._v(" "), _c('v-divider', {
    staticClass: "Rightbar_card_divider"
  }), _vm._v(" "), _c('span', {
    staticClass: "Rightbar_card_content_subheading"
  }, [(!_vm.openEditBoxPhenolyzer) ? _c('span', [_c('strong', {
    staticClass: "Rightbar_card_content_heading"
  }, [_vm._v(_vm._s(_vm.selected.length))])]) : _c('span', [_c('div', {
    staticStyle: {
      "display": "inline-block",
      "padding-top": "5px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.genesTop),
      expression: "genesTop"
    }],
    staticClass: "form-control",
    staticStyle: {
      "margin-bottom": "8px",
      "width": "82%"
    },
    attrs: {
      "disabled": _vm.multipleSearchTerms.length < 1,
      "id": "top-genes-phenolyzer",
      "type": "text",
      "autocomplete": "off",
      "list": "genes"
    },
    domProps: {
      "value": (_vm.genesTop)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.genesTop = $event.target.value
      }
    }
  }), _vm._v(" "), _c('datalist', {
    attrs: {
      "id": "genes"
    }
  }, _vm._l((_vm.genesTopCounts), function(genesCount) {
    return _c('option', [_vm._v("\n                                        " + _vm._s(genesCount) + "\n                                      ")])
  }))])]), _vm._v("\n                                of " + _vm._s(_vm.items.length) + " genes selected\n                                "), (!_vm.openEditBoxPhenolyzer) ? _c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "slot": "activator"
    },
    on: {
      "click": function($event) {
        _vm.openEditBoxPhenolyzer = true
      }
    },
    slot: "activator"
  }, [_vm._v("\n                                   edit\n                                 ")]), _vm._v(" "), _c('span', [_vm._v("Edit the number of genes selected")])], 1) : _c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "slot": "activator"
    },
    on: {
      "click": function($event) {
        _vm.openEditBoxPhenolyzer = false
      }
    },
    slot: "activator"
  }, [_vm._v("\n                                  close\n                                ")]), _vm._v(" "), _c('span', [_vm._v("Close the edit box")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "text-xs-center"
  }, [(_vm.items.length > 0) ? _c('progressCircularDonut', {
    attrs: {
      "selectedNumber": _vm.selected.length,
      "totalNumber": _vm.items.length
    }
  }) : _vm._e()], 1)], 1)], 1)], 1) : _vm._e()])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [(!_vm.phenotypeSearchedByUser) ? _c('div', [_c('v-card-title', [_c('h3', [_vm._v(_vm._s(_vm.IntroductionTextData.Title))])]), _vm._v(" "), _c('v-card-text', {
    domProps: {
      "innerHTML": _vm._s(_vm.IntroductionTextData.Content)
    }
  })], 1) : _vm._e()])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "d-flex": "",
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-card', [_c('ContentLoaderPlaceholder', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.checked === true),
      expression: "checked===true"
    }]
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.multipleSearchTerms.length) ? _c('v-card', [_c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "id": "genes-table",
      "headers": _vm.headers,
      "items": _vm.items,
      "select-all": "",
      "pagination": _vm.pagination,
      "item-key": "geneName",
      "search": _vm.search,
      "no-data-text": "No pheotype genes Available Currently",
      "custom-filter": _vm.filterItemsOnSearchPhenolyzer
    },
    on: {
      "update:pagination": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "headers",
      fn: function(props) {
        return [_c('tr', [_c('th', [_c('v-checkbox', {
          attrs: {
            "primary": "",
            "hide-details": "",
            "input-value": props.all,
            "indeterminate": props.indeterminate
          },
          nativeOn: {
            "click": function($event) {
              return _vm.toggleAll($event)
            }
          }
        })], 1), _vm._v(" "), _vm._l((props.headers), function(header) {
          return _c('th', {
            key: header.text,
            class: ['column sortable', _vm.pagination.descending ? 'desc' : 'asc', header.value === _vm.pagination.sortBy ? 'active' : '']
          }, [(header.text === 'Gene Name') ? _c('span', [_c('div', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (!_vm.openSearchBox),
              expression: "!openSearchBox"
            }]
          }, [_vm._v("\n                           " + _vm._s(header.text) + "     "), _c('v-icon', {
            staticStyle: {
              "opacity": "2",
              "color": "#222",
              "cursor": "pointer"
            },
            attrs: {
              "right": ""
            },
            on: {
              "click": function($event) {
                _vm.openSearchBox = true
              }
            }
          }, [_vm._v("search")])], 1), _vm._v(" "), _c('div', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (_vm.openSearchBox),
              expression: "openSearchBox"
            }]
          }, [_c('v-layout', [_c('v-flex', {
            staticStyle: {
              "margin-top": "-30px"
            },
            attrs: {
              "xs8": ""
            }
          }, [_c('div', {
            attrs: {
              "id": "geneSearchBoxPhenolyzer"
            }
          }, [_c('v-text-field', {
            attrs: {
              "label": "Search for Gene",
              "prepend-icon": "search",
              "single-line": "",
              "hide-details": ""
            },
            model: {
              value: (_vm.search),
              callback: function($$v) {
                _vm.search = $$v
              },
              expression: "search"
            }
          })], 1)]), _vm._v(" "), _c('v-flex', {
            attrs: {
              "xs1": ""
            }
          }, [_c('v-icon', {
            staticStyle: {
              "opacity": "2",
              "color": "#222",
              "cursor": "pointer"
            },
            on: {
              "click": function($event) {
                _vm.openSearchBox = false
              }
            }
          }, [_vm._v("close")])], 1)], 1)], 1)]) : _c('span', [_vm._v(_vm._s(header.text))])])
        })], 2)]
      }
    }, {
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          attrs: {
            "active": props.selected
          }
        }, [_c('td', [_c('v-checkbox', {
          attrs: {
            "primary": "",
            "hide-details": "",
            "input-value": props.selected
          },
          model: {
            value: (props.selected),
            callback: function($$v) {
              _vm.$set(props, "selected", $$v)
            },
            expression: "props.selected"
          }
        })], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.indexVal))]), _vm._v(" "), _c('td', [_c('span', {
          staticStyle: {
            "font-size": "14px",
            "font-weight": "600",
            "margin-top": "2px"
          },
          attrs: {
            "slot": "activator"
          },
          slot: "activator"
        }, [_vm._v(_vm._s(props.item.geneName))])]), (_vm.multipleSearchTerms.length > 1) ? _c('td', _vm._l((props.item.searchTermIndexSVG), function(x) {
          return _c('span', [_c('span', {
            domProps: {
              "innerHTML": _vm._s(x)
            }
          })])
        })) : _vm._e(), _vm._v(" "), _c('td', [_c('span', {
          domProps: {
            "innerHTML": _vm._s(props.item.htmlData)
          }
        })]), _vm._v(" "), _c('td', {
          staticStyle: {
            "font-size": "0px"
          }
        }, [_vm._v(_vm._s(props.item.score))]), _vm._v(" "), _c('td', [_c('v-menu', {
          staticStyle: {
            "color": "black"
          },
          attrs: {
            "bottom": "",
            "offset-y": ""
          }
        }, [_c('v-icon', {
          staticStyle: {
            "padding-right": "4px"
          },
          attrs: {
            "slot": "activator"
          },
          slot: "activator"
        }, [_vm._v("more_vert")]), _vm._v(" "), _c('v-card', [_c('div', {
          staticClass: "conditionsBox"
        }, [_c('v-list', [_c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_c('strong', {
          staticStyle: {
            "font-size": "18px"
          }
        }, [_vm._v(" Gene Resource Links  "), _c('i', [_vm._v("( " + _vm._s(props.item.geneName) + " )")])])])], 1)], 1), _vm._v(" "), _c('v-divider', {
          staticClass: "Rightbar_card_divider"
        }), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_c('strong', [_vm._v("MedGen")]), _c('a', {
          attrs: {
            "href": props.item.medGenSrc,
            "target": "_blank"
          }
        }, [_c('v-btn', {
          attrs: {
            "small": "",
            "round": "",
            "outline": "",
            "color": "primary"
          }
        }, [_vm._v("Link")])], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n                                       MedGen organizes information related to human medical genetics, such as attributes of conditions with a genetic contribution.\n                                    ")])], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_c('strong', [_vm._v("OMIM")]), _c('a', {
          attrs: {
            "href": props.item.omimSrc,
            "target": "_blank"
          }
        }, [_c('v-btn', {
          attrs: {
            "small": "",
            "round": "",
            "outline": "",
            "color": "primary"
          }
        }, [_vm._v("Link")])], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n                                      OMIM is a comprehensive, authoritative compendium of human genes and genetic phenotypes\n                                    ")])], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_c('strong', [_vm._v("GeneCards")]), _c('a', {
          attrs: {
            "href": props.item.geneCardsSrc,
            "target": "_blank"
          }
        }, [_c('v-btn', {
          attrs: {
            "small": "",
            "round": "",
            "outline": "",
            "color": "primary"
          }
        }, [_vm._v("Link")])], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n                                     GeneCards is a searchable, integrative database that provides comprehensive, user-friendly information on all annotated and predicted human genes.\n                                   ")])], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_c('strong', [_vm._v("Genetics Home Reference")]), _c('a', {
          attrs: {
            "href": props.item.ghrSrc,
            "target": "_blank"
          }
        }, [_c('v-btn', {
          attrs: {
            "small": "",
            "round": "",
            "outline": "",
            "color": "primary"
          }
        }, [_vm._v("Link")])], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n                                    Genetics Home Reference provides consumer-friendly information about the effects of genetic variation on human health.\n                                  ")])], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_c('strong', [_vm._v("ClinGen")]), _c('a', {
          attrs: {
            "href": props.item.clinGenLink,
            "target": "_blank"
          }
        }, [_c('v-btn', {
          attrs: {
            "small": "",
            "round": "",
            "outline": "",
            "color": "primary"
          }
        }, [_vm._v("Link")])], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n                                   The Clinical Genome Resource (ClinGen) consortium curates genes and regions of the genome to assess whether there is evidence to support that these genes/regions are dosage sensitive and should be targeted on a cytogenomic array                       ")])], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_c('strong', [_vm._v("Gene ID "), _c('i', [_vm._v(" ( " + _vm._s(props.item.geneId) + " )")])]), _c('a', {
          attrs: {
            "href": props.item.geneIdLink,
            "target": "_blank"
          }
        }, [_c('v-btn', {
          attrs: {
            "small": "",
            "round": "",
            "outline": "",
            "color": "primary"
          }
        }, [_vm._v("Link")])], 1)]), _vm._v(" "), _c('br')], 1)], 1), _vm._v(" "), _c('br')], 1)], 1)])], 1)], 1)])]
      }
    }]),
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  }, [_c('template', {
    slot: "footer"
  })], 2)], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    class: [(_vm.browser === 'Chrome' && _vm.isMobile === false) || (_vm.browser === 'Firefox' && _vm.isMobile === false) ? 'flex xs4 pr-2 pl-2' : 'flex xs3 pr-2 pl-2']
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-container', {
    staticStyle: {
      "min-height": "500px"
    },
    attrs: {
      "fluid": "",
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    staticStyle: {
      "margin-top": "-20px",
      "margin-left": "-20px",
      "margin-right": "-20px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "d-flex": "",
      "xs12": "",
      "sm12": "",
      "md12": "",
      "lg12": ""
    }
  }, [_c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(false) ? _c('v-flex', {
    attrs: {
      "d-flex": "",
      "xs12": "",
      "sm12": "",
      "md12": "",
      "lg12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "d-flex": "",
      "xs12": "",
      "sm12": "",
      "md12": "",
      "lg12": ""
    }
  }, [_c('v-card', [_c('v-card-text', {
    staticStyle: {
      "padding": "5px"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "d-flex": "",
      "xs12": "",
      "sm12": "",
      "md4": "",
      "lg4": ""
    }
  }, [_c('center')], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "d-flex": "",
      "xs12": "",
      "sm12": "",
      "md4": "",
      "lg4": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "d-flex": "",
      "xs12": "",
      "sm12": "",
      "md4": "",
      "lg4": ""
    }
  })], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')], 1)], 1)], 1)], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4983f14c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/app/components/pages/Phenolyzer.vue
// module id = 508
// module chunks = 0